import { render, staticRenderFns } from "./room-push.vue?vue&type=template&id=21ae5d34&scoped=true&"
import script from "./room-push.vue?vue&type=script&lang=js&"
export * from "./room-push.vue?vue&type=script&lang=js&"
import style0 from "./room-push.vue?vue&type=style&index=0&id=21ae5d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae5d34",
  null
  
)

export default component.exports